/* eslint-disable import/prefer-default-export */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable func-names */
import * as yup from 'yup';

const VendorSettingSchema = yup.object().shape({
    vendorName: yup.string().required().max(100),
    vendorType: yup.string().required(),
    vendorAddress: yup.string().nullable().max(50),
    vendorCity: yup.string().nullable().max(35),
    vendorState: yup.string().nullable().max(50),
    vendorZip: yup.string().nullable().max(6),
    vendorPhone: yup.string().nullable().max(12),
    vendorFax: yup.string().nullable().max(12),
    vendorContact: yup.string().nullable().max(30),
    vendorFednid: yup.string().nullable().max(25),
    vendorCrNumber: yup.string().nullable().max(50),
    provider: yup.string().nullable().max(50),
});

export {
    VendorSettingSchema,
};
